import { render } from "./DetailPengajuan.vue?vue&type=template&id=341e94b0&scoped=true"
import script from "./DetailPengajuan.vue?vue&type=script&lang=js"
export * from "./DetailPengajuan.vue?vue&type=script&lang=js"

import "./DetailPengajuan.vue?vue&type=style&index=0&id=341e94b0&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341e94b0"]])

export default __exports__